import React from "react"
import BlockWrapper from "../technical/BlockWrapper"
import Image from "../atoms/Image"
import ButtonGroup from "../molecules/ButtonGroup"
import ShareButton from "../atoms/ShareButton"

const HeroBlock = ({ block, heroSize = "normal" }) => {
  return (
    <>
      {block.image?.filename?.length > 0 && (
        <BlockWrapper
          block={block}
          blockPadding="pb-block"
          blockWidth="screen"
          showHeadline="false"
        >
          <div
            className={`relative max-w-screen-xl lg:px-4 mx-auto block overflow-hidden h-screen-50 ${
              heroSize === "normal" ? "lg:h-screen-50" : "lg:h-screen-70"
            }`}
          >
            <Image
              image={block.image}
              title={block.title}
              alt={block.alt}
              className="object-cover w-auto h-full lg:w-full lg:h-auto"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 lg:mx-4">
              <ShareButton btnType="white" className="lg:mr-4" />
              <div className="flex flex-col items-center justify-center w-full h-full max-w-screen-xl mx-auto text-center text-white">
                <div className="max-w-screen-md px-grid">
                  {block.kicker?.length > 0 && (
                    <span className="text-white kicker kicker-h1">
                      {block.kicker}
                    </span>
                  )}
                  {block.headline?.length > 0 && (
                    <h1
                      className="text-white headline headline-h1"
                      dangerouslySetInnerHTML={{
                        __html: block.headline.replace(/#/i, "<br />"),
                      }}
                    />
                  )}
                  {block.subheadline?.length > 0 && (
                    <span className="text-white subheadline subheadline-h1">
                      {block.subheadline}
                    </span>
                  )}
                </div>
                <ButtonGroup className="mt-8" buttons={block.buttons} />
                {block.logo?.filename && (
                  <div className="absolute bottom-0 right-0 p-4 bg-white lg:bottom-auto">
                    <Image
                      image={block.logo.filename}
                      className="block w-32 h-auto"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </BlockWrapper>
      )}
    </>
  )
}

export default HeroBlock
